// hooks/usePaymentProcesses.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
    useGetAllProcesses, 
    useUpdateProcess, 
    useDeleteProcess, 
    useImportProcesses 
} from '@/shared/api/client/fsp-payment-processes';
import { FspPaymentProcessDTO, FspPaymentProcessIdentifier, FspPaymentProcessImportDTO } from '@/shared/api/model';

export const useFspPaymentProcesses = () => {
    const query = useGetAllProcesses();
    
    return {
        ...query,
        data: query.data,
        error: query.error
    };
};

export const useUpdateFspPaymentProcess = () => {
    const queryClient = useQueryClient();

    const mutation = useUpdateProcess({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({queryKey:['paymentProcesses']});
            }
        }
    });
    
    // Maintain backward compatibility
    return {
        ...mutation,
        mutateAsync: (process: FspPaymentProcessDTO) => 
            mutation.mutateAsync({ data: process })
                .then(response => response)
    };
};

export const useDeleteFspPaymentProcess = () => {
    const queryClient = useQueryClient();

    const mutation = useDeleteProcess({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({queryKey:['paymentProcesses']});
            }
        }
    });
    
    // Maintain backward compatibility
    return {
        ...mutation,
        mutateAsync: (processId: FspPaymentProcessIdentifier) => 
            mutation.mutateAsync({ data: processId })
                .then(response => response)
    };
};

export const useImportFspPaymentProcesses = () => {
    const queryClient = useQueryClient();

    const mutation = useImportProcesses({
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries({queryKey:['paymentProcesses']});
            }
        }
    });
    
    // Maintain backward compatibility
    return {
        ...mutation,
        mutateAsync: (importDto: FspPaymentProcessImportDTO) => 
            mutation.mutateAsync({ data: importDto })
                .then(response => response)
    };
};